import { prettyMoney } from "@helpers/currency";
import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const RevenueGraph = (props) => {
  const tickFormatter = (value) => {
    return props.symbol === "£"
      ? `${props.symbol}${prettyMoney(value, 2)}`
      : `${value}${props.symbol}`;
  };

  const toolTipFormatter = (value) => {
    return props.symbol === "£"
      ? `${props.symbol}${prettyMoney(value, 2)}`
      : `${value}${props.symbol}`;
  };

  return (
    <ResponsiveContainer width="99%" aspect={props.aspect || 6}>
      <LineChart data={props.data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis
          width={80}
          tickFormatter={props.tickFormatter || tickFormatter}
        />
        <Tooltip formatter={props.toolTipFormatter || toolTipFormatter} />
        {props.data && <Legend />}
        {props.lines.map((line) => (
          <Line
            type="monotone"
            dataKey={line.key}
            name={line.label}
            stroke={line.colour}
            strokeWidth="2"
            dot={{ strokeWidth: 1, r: 4 }}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RevenueGraph;
